<template>
  <b-sidebar
    :id="idSidebar"
    bg-variant="white"
    sidebar-class="sidebar-xl"
    shadow
    backdrop
    no-header
    right
  >
    <template
      v-if="!isEmptyObject(datos)"
      #default="{ hide }"
    >
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1 border-left-primary border-left-5">
        <h5 class="mb-0">
          Acerca de este Modulo
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="20"
          @click="hide"
        />
      </div>

      <blockquote class="blockquote pl-1 pt-2 pb-2 text-left border-left-primary border-left-5">
        <p class="mb-0">
          {{ datos.seccion.nombre }}
        </p>
        <footer class="blockquote-footer">
          <cite title="Source Title">{{ datos.seccion.desc }}</cite>
        </footer>
      </blockquote>
      <!-- AYUDA GENERAL-CONCEPTOS -->
      <b-container>
        <app-collapse
          type="margin"
          class="mb-2"
        >
          <app-collapse-item
            v-for="(obj, index) in datos.procesos"
            :key="index"
            :title="`${obj.titulo || 'No disponible'}`"
          >
            {{ obj.desc }}
          </app-collapse-item>
        </app-collapse>
      </b-container>
      <!-- Lista sin iconos -->
      <app-timeline class="mt-1 p-1">
        <app-timeline-item
          v-for="modulo in datos.guiaA"
          :key="modulo.id"
        >
          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6><b>{{ modulo.titulo }}</b></h6>
          </div>
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="modulo.desc" />
          <!-- eslint-enable -->
        </app-timeline-item>
        <!-- Lista con Icono -->
        <app-timeline-item
          v-for="modulo in datos.guiaB"
          :key="modulo.id"
          :title="modulo.titulo"
          :subtitle="modulo.desc"
          :icon="modulo.icon"
          :time="`#${modulo.tag}`"
          :variant="modulo.color"
        />
      </app-timeline>
    </template>
    <template v-if="isEmptyObject(datos)">
      <span>Datos no cargados</span>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, VBToggle, BContainer,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import Ripple from 'vue-ripple-directive'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import { isEmptyObject } from '@core/utils/utils'

export default {
  components: {
    BSidebar,
    AppTimeline,
    AppTimelineItem,
    BContainer,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  props: {
    idSidebar: {
      type: String,
      required: true,
    },
    datos: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  setup() {
    return {
      isEmptyObject,
    }
  },
}
</script>
